import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "space-y-3" }
const _hoisted_5 = { class: "flex items-center gap-3 p-3 bg-gray-50 rounded-lg" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "text-sm text-gray-600" }
const _hoisted_8 = { class: "flex items-center gap-3 p-3 bg-gray-50 rounded-lg" }
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = { class: "text-sm text-gray-600" }
const _hoisted_11 = { class: "flex items-center gap-3 p-3 bg-gray-50 rounded-lg" }
const _hoisted_12 = { class: "flex-1" }
const _hoisted_13 = { class: "text-sm text-gray-600" }
const _hoisted_14 = { class: "flex items-center gap-3 p-3 bg-gray-50 rounded-lg" }
const _hoisted_15 = { class: "flex-1" }
const _hoisted_16 = { class: "text-sm text-gray-600" }
const _hoisted_17 = { class: "space-y-4" }

import { ref, watch } from 'vue'
import { ModalComp } from '@/components'
import { useAuthStore } from '@/stores/auth'
import { getVendeurGeneralInfo } from '@/api/vendeur'

interface Props {
  isVisible: boolean
  isLoading: boolean
  vendeurData: any
}

interface Emits {
  (e: 'update:isVisible', value: boolean): void
  (e: 'show-contact-modal'): void
}

const LOCAL_STORAGE_KEY = 'vendeur_info_header'

type VendeurMini = {
  email?: string
  telephone?: string
  mobile?: string
  adresse?: string
  code_postal?: string
  ville?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserModal',
  props: {
    isVisible: { type: Boolean },
    isLoading: { type: Boolean },
    vendeurData: {}
  },
  emits: ["update:isVisible", "show-contact-modal"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const authStore = useAuthStore()

// Local state for data loading on mobile
const isLoadingLocal = ref(false)
const DEFAULT_VENDEUR: VendeurMini = {
  email: undefined,
  telephone: undefined,
  mobile: undefined,
  adresse: undefined,
  code_postal: undefined,
  ville: undefined
}

const displayVendeur = ref<VendeurMini>({ ...DEFAULT_VENDEUR, ...(props.vendeurData || {}) })

const isBusy = ref(false)
watch(
  () => props.isVisible,
  async (open) => {
    if (!open) return
    isBusy.value = true
    isLoadingLocal.value = true
    try {
      // 1) Try from localStorage (already filled by navbar on desktop or earlier)
      const raw = localStorage.getItem(LOCAL_STORAGE_KEY)
      if (raw) {
        try {
          const parsed = JSON.parse(raw) as VendeurMini
          if (Object.prototype.hasOwnProperty.call(parsed, 'ville')) {
            displayVendeur.value = { ...DEFAULT_VENDEUR, ...parsed }
            return
          }
        } catch {
          // ignore parse error and fall back to API
        }
      }

      // 2) Fallback: fetch from API
      const profile = await getVendeurGeneralInfo()
      const storeAddress = (profile as any).adresses?.find((addr: any) => addr.type === 2) || (profile as any).adresses?.[0]
      displayVendeur.value = {
        email: (profile as any).email,
        telephone: storeAddress?.telephone,
        mobile: storeAddress?.mobile,
        adresse: storeAddress?.adresse,
        code_postal: storeAddress?.codePostal,
        ville: storeAddress?.ville
      }
    } catch (e) {
      // keep defaults
      // Erreur silencieuse - les infos vendeur n'ont pas été chargées
    } finally {
      isLoadingLocal.value = false
      isBusy.value = false
    }
  },
  { immediate: false }
)

function seDeconnecter() {
  authStore.logout();
}

function contactUs() {
  emit('show-contact-modal')
  emit('update:isVisible', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalComp), {
    "is-visible": _ctx.isVisible,
    "onUpdate:isVisible": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:isVisible', $event))),
    size: "sm",
    "hide-footer": true
  }, {
    header: _withCtx(() => _cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "flex items-center gap-3" }, [
        _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center" }, [
          _createElementVNode("i", { class: "fas fa-user text-blue-600 text-lg" })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-xl font-semibold text-gray-800" }, "Mon profil"),
          _createElementVNode("p", { class: "text-sm text-gray-600" }, "Informations et liens utiles")
        ])
      ], -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (isBusy.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-spinner fa-spin text-blue-600 text-xl" }, null, -1),
              _createElementVNode("p", { class: "text-sm text-gray-600 mt-2" }, "Chargement des informations...", -1)
            ])))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-800 flex items-center gap-2" }, [
                  _createElementVNode("i", { class: "fas fa-user-circle text-blue-600" }),
                  _createTextVNode(" Informations personnelles ")
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-envelope text-gray-500 w-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, "Email", -1)),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(displayVendeur.value.email || 'Non disponible'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-phone text-gray-500 w-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, "Téléphone fixe", -1)),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(displayVendeur.value.telephone || 'Non disponible'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-mobile-alt text-gray-500 w-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, "Téléphone mobile", -1)),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(displayVendeur.value.mobile || 'Non disponible'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-map-marker-alt text-gray-500 w-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, "Adresse", -1)),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(displayVendeur.value.adresse || 'Non disponible') + ", " + _toDisplayString(displayVendeur.value.code_postal || 'Non disponible') + " " + _toDisplayString(displayVendeur.value.ville || 'Non disponible'), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-800 flex items-center gap-2" }, [
                  _createElementVNode("i", { class: "fas fa-external-link-alt text-blue-600" }),
                  _createTextVNode(" Liens utiles ")
                ], -1)),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(contactUs, ["prevent"]),
                  class: "flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("i", { class: "fas fa-headset text-gray-500 w-5" }, null, -1),
                  _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Contactez nous", -1)
                ])),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "space-y-2" }, [
                  _createElementVNode("a", {
                    href: "https://knowledge.efashion-paris.com/vendors",
                    target: "_blank",
                    class: "flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                  }, [
                    _createElementVNode("i", { class: "fas fa-book text-gray-500 w-5" }),
                    _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Guide Efashion")
                  ]),
                  _createElementVNode("a", {
                    href: "https://landingpage.efashion-paris.com/fr/conditions-g%C3%A9n%C3%A9rales-dutilisation-grossistes-vendeurs",
                    target: "_blank",
                    class: "flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                  }, [
                    _createElementVNode("i", { class: "fas fa-file-contract text-gray-500 w-5" }),
                    _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "CGUV")
                  ])
                ], -1))
              ]),
              _createElementVNode("div", { class: "pt-4 border-t border-gray-200" }, [
                _createElementVNode("button", {
                  onClick: seDeconnecter,
                  class: "w-full flex items-center gap-2 p-3 bg-red-50 rounded-lg hover:bg-red-100 transition-colors text-red-600"
                }, _cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "fas fa-sign-out-alt w-4" }, null, -1),
                  _createElementVNode("span", { class: "text-xs font-medium" }, "Déconnexion", -1)
                ]))
              ])
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})